module.exports = __webpack_public_path__ + "img/legacy-shape-2.55eaca27.png";